import * as React from 'react';
import {connect} from 'react-redux';

import {Modal} from 'shells/modal/modal';
import {ModalActionButton} from 'shells/modal/modal-action-button';

import {GetSessionUser} from '../../../core/get-session-user';

import {appHistory} from '../../../../history';
import type {NutshellState} from '../../../../store';

// @ts-expect-error
import * as actions from '../../dashboard-actions';
import {getDashLabel, getDashDefaults} from '../../dashboard-constants';
// @ts-expect-error
import * as dashboardSelectors from '../../dashboard-selectors';

// @ts-expect-error
import * as configSelectors from './config-selectors';
// @ts-expect-error
import {DashConfigForm} from './dash-config-form';
// @ts-expect-error
import {NewDashSelector} from './new-dash-selector';

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        dashboardPreview: configSelectors.getDashboardPreview(state),
        previewIsLoading: configSelectors.getPreviewIsLoading(state),
        previewIsRefreshing: configSelectors.getPreviewIsRefreshing(state),
        previewErrorMessage: configSelectors.getPreviewErrorMessage(state),
        selectedDash: configSelectors.getSelectedDash(state),
        isSelectingDashType: dashboardSelectors.getIsSelectingDashType(state),
        shouldShowBackButton: dashboardSelectors.getIsAddingNewDash(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = (dispatch): DispatchProps => {
    return {
        getConfigData: () => {
            dispatch(actions.fetchDashboardData());
        },
        getDashboardPreview: (formValues) => {
            dispatch(actions.fetchDashboardPreview(formValues));
        },
        handleSelectNewDashType: (type) => {
            dispatch(actions.toggleConfigureDash(`new-${type}`));
        },
        handleBackButtonPress: () => {
            dispatch(actions.addNewDash());
            dispatch(actions.clearDashboardPreview());
        },
    };
};

type OwnProps = {
    onClose: () => any;
};

type StateProps = {
    previewIsLoading: boolean;
    previewIsRefreshing: boolean;
    previewErrorMessage?: string;
    dashboardPreview: any | null | undefined;
    selectedDash?: any;
    isSelectingDashType: boolean;
    shouldShowBackButton: boolean;
};

type DispatchProps = {
    getConfigData: () => any;
    getDashboardPreview: (formValues: any) => any;
    handleSelectNewDashType: (dashType: string) => any;
    handleBackButtonPress: () => any;
};

type Props = OwnProps & StateProps & DispatchProps;

export class ConfigModalComponent extends React.PureComponent<Props> {
    UNSAFE_componentWillMount() {
        this.props.getConfigData();
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.selectedDash && !this.props.selectedDash) {
            // Remove any rehydrated form state
            this.props.getDashboardPreview({
                name: nextProps.selectedDash.name,
                value: nextProps.selectedDash.value,
            });
        }
    }

    render() {
        let initialValues;
        const isOpen = Boolean(this.props.isSelectingDashType || this.props.selectedDash);
        if (this.props.selectedDash) {
            initialValues = {...getDashDefaults(this.props.selectedDash.type)};

            if (this.props.selectedDash && this.props.selectedDash.name) {
                // @ts-expect-error
                initialValues.name = this.props.selectedDash.name;
            }
            if (this.props.selectedDash && this.props.selectedDash.value) {
                // @ts-expect-error
                initialValues.value = this.props.selectedDash.value;
            }
        }

        return (
            <Modal
                isOpen={isOpen}
                headerBackButton={this.props.shouldShowBackButton}
                onHeaderBackButtonPress={this.props.handleBackButtonPress}
                headerText={this.getModalHeaderText()}
                onClose={this.props.onClose}
                maxHeight={
                    // Give list a little extra height
                    this.props.selectedDash && this.props.selectedDash.type === 'list' ? 615 : 590
                }
                actionButton={
                    <GetSessionUser>
                        {/* @ts-expect-error */}
                        {({user}) => {
                            return user &&
                                user.permissions.canAccessSetup &&
                                this.props.selectedDash &&
                                this.props.selectedDash.id === 'new-dashboardQuotas' ? (
                                <ModalActionButton
                                    onClick={() => appHistory.push('/setup/quota')}
                                    tooltipText='Assign quotas'
                                />
                            ) : null;
                        }}
                    </GetSessionUser>
                }
            >
                {this.props.selectedDash ? (
                    <DashConfigForm
                        initialValues={initialValues}
                        isLoading={this.props.previewIsLoading}
                        isRefreshing={this.props.previewIsRefreshing}
                        errorMessage={this.props.previewErrorMessage}
                        dashboardPreview={this.props.dashboardPreview}
                        dash={this.props.selectedDash}
                        onModalClose={this.props.onClose}
                    />
                ) : (
                    <NewDashSelector onSelect={this.handleSelectNewDashType} />
                )}
            </Modal>
        );
    }

    getModalHeaderText() {
        if (this.props.isSelectingDashType) {
            return 'Create new dashboard card';
        } else if (this.props.selectedDash && isUnsavedDash(this.props.selectedDash.id)) {
            return `Create new ${getDashLabel(this.props.selectedDash.type).toLowerCase()} card`;
        } else if (this.props.selectedDash && this.props.selectedDash.name) {
            return `Edit ${this.props.selectedDash.name} card`;
        } else {
            return 'Dashboard card';
        }
    }

    handleSelectNewDashType = (type: string) => {
        if (!this.props.isSelectingDashType) return;
        this.props.handleSelectNewDashType(type);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const ConfigModal = connector(ConfigModalComponent);

/*
 * Helper functions
 */

// @ts-expect-error
function isUnsavedDash(dashId) {
    if (!dashId) return false;

    return dashId.startsWith('new-');
}
